import React, { useState, createContext, useMemo } from "react";

export const MenuContext = createContext({
  menuState: "closed",
  toggleMenu: () => {},
  closeMenu: () => {},
});

export function MenuProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const menuState = useMemo(() => (isOpen ? "open" : "closed"), [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const provider = {
    menuState,
    toggleMenu,
    closeMenu,
  };

  return (
    <MenuContext.Provider value={provider}>{children}</MenuContext.Provider>
  );
}
